class OrganizationRole {
  constructor(title) {
    this.title = title;
  }
}
export default {
  inject: ['load'],
  data() {
    return {
      allOrganizationRoles: [],
      allOrganizationRolesForOther: [],
      organizationRole: new OrganizationRole(''),
    };
  },
  methods: {
    getListOfOrganizationRolesForOther: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getAllOrganizationRoles').then(() => {
        if (this.$store.state.organizationRoleModule.successFlag) {
          this.allOrganizationRolesForOther =
            this.$store.state.organizationRoleModule.allOrganizationRoles;
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.organizationRoleModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getListOfOrganizationRolesForOther();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.organizationRoleModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getListOfOrganizationRolesForOther();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getAllOrganizationRoles: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getAllOrganizationRoles').then(() => {
        if (this.$store.state.organizationRoleModule.successFlag) {
          this.allOrganizationRoles = this.$store.state.organizationRoleModule.allOrganizationRoles;
          this.allOrganizationRoles.forEach((c) => (c.isEdit = false));
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.organizationRoleModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getAllOrganizationRoles();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.organizationRoleModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getAllOrganizationRoles();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    addOrganizationRoleFunction: function () {
      if (!this.organizationRole.title) {
        this.snackText = 'عنوان سمت نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.organizationRole.title.replace(/\s/g, '').length) {
        this.snackText = 'عنوان سمت نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('addOrganizationRole', this.organizationRole).then(() => {
        if (this.$store.state.organizationRoleModule.successFlag) {
          this.$refs.confirm.showConfirmDialog = false;
          this.showAddEditModal = false;
          this.disabelConfirm = false;
          this.snackText = ' سمت با موفقیت اضافه شد';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#4CAF50';
          this.snakIcon = 'mdi-check-circle';
          if (this.load.val) {
            this.load.val = false;
          }
          this.organizationRole = new OrganizationRole('');
          this.getAllOrganizationRoles();
        } else {
          this.disabelConfirm = false;
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.organizationRoleModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.addOrganizationRoleFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.organizationRoleModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.addOrganizationRoleFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getOrganizationRoleFunction: function (id) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getOrganizationRole', id).then(() => {
        if (this.$store.state.organizationRoleModule.successFlag) {
          this.organizationRole = this.$store.state.organizationRoleModule.organizationRole;
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.organizationRoleModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getOrganizationRoleFunction(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.organizationRoleModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getOrganizationRoleFunction(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    editOrganizationRoleFunction: function () {
      if (!this.organizationRole.title) {
        this.snackText = 'عنوان سمت نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.organizationRole.title.replace(/\s/g, '').length) {
        this.snackText = 'عنوان سمت نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('editOrganizationRole', this.organizationRole).then(() => {
        if (this.$store.state.organizationRoleModule.successFlag) {
          this.$refs.confirm.showConfirmDialog = false;
          this.disabelConfirm = false;
          this.showAddEditModal = false;
          if (this.load.val) {
            this.load.val = false;
          }
          this.getAllOrganizationRoles();
          this.snackText = ' سمت با موفقیت ویرایش شد';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#4CAF50';
          this.snakIcon = 'mdi-check-circle';
          this.organizationRole = new OrganizationRole('');
        } else {
          this.disabelConfirm = false;
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.organizationRoleModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.editOrganizationRoleFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.organizationRoleModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.editOrganizationRoleFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    deleteOrganizationRoleFunction: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('deleteOrganizationRole', this.organizationRoleId).then(() => {
        if (this.$store.state.organizationRoleModule.successFlag) {
          this.disabelConfirm = false;
          this.$refs.confirm.showConfirmDialog = false;
          if (this.load.val) {
            this.load.val = false;
          }
          this.getAllOrganizationRoles();
          this.snackText = ' سمت با موفقیت حذف شد';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#4CAF50';
          this.snakIcon = 'mdi-check-circle';
        } else {
          this.disabelConfirm = false;
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.organizationRoleModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.deleteOrganizationRoleFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.organizationRoleModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.deleteOrganizationRoleFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    showError: function () {
      this.snackText = this.$store.state.organizationRoleModule.error;
      this.$refs.snackRef.snackModel = true;
      this.snackColor = '#FF5252';
      this.snakIcon = 'mdi-information';
    },
  },
};
